export default class JobUserFullAdapter {
    static toDalUserJob(job) {
        return {
            UserId: job.UserId,
            JobId: job.JobId,
            JobName: job.Job.Name
        };
    }
}
